<template>
  <div :class="elementClass">
    <slot></slot>
  </div>
</template>

<script>
import { cardClass } from "../prefix";
export default {
  computed: {
    elementClass() {
      return cardClass;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-card";

#{$element} {
  background: $color-white;
  width: 100%;
  will-change: transform, height;
  @include transition(all 1s linear);
  border: 1px solid $color-grey-200;
  border-radius: 8px;
}
</style>
